module.exports = __webpack_public_path__ + "static/media/Hero_canada_mobile.647af471.png";